import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';

import { workersTableColumns } from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList/WorkersTable/logic';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { Table } from '@/shared/components/atoms';

interface IWorkdaySupplierDetailsTable {
  workers?: IPrintingOrders.IWorkerItem[];
}

export default function WorkersTable({
  workers,
}: IWorkdaySupplierDetailsTable): ReactElement {
  const { t } = useTranslation('common');

  return (
    <div className=''>
      <Table<IPrintingOrders.IWorkerItem>
        selection={false}
        columns={workersTableColumns(t)}
        tableClassName='text-left'
        data={workers || []}
        pagination={false}
        noDataMessage={t('no-data')}
      />
    </div>
  );
}
